import { MeasurementSchema } from '@weft/types';

import { oz } from '@weft/utils';

export const GetMeasurementsResponseSchema = oz.object({
  measurements:  oz.array(MeasurementSchema),
}).openapi('GetMeasurementsResponse');

export type GetMeasurementsResponse = oz.infer<typeof GetMeasurementsResponseSchema>;